import React from "react";
import Company_logo from "../../../assets/Company_logo.svg";

import Classes from "./Style.module.css";
const Index = () => {
  return (
    <div>
      <div className={Classes.Footer}>
        <div className={Classes.Footer_top}>
          <div className={Classes.Company_logo_Footer}>
            <img
              style={{ objectFit: "contain" }}
              src={Company_logo}
              alt={Company_logo}
            />
          </div>
          <div className={Classes.Footer_menu_primary}>
            <div>
              <p>Directions</p>
              <p>Giri Hotels</p>
              <p>BookDirect FAQ</p>
              <p>Safety FAQ</p>
              <p>Choice Privileges</p>
            </div>
          </div>
          <div className={Classes.Footer_menu_secondary}>
            <div>
              <p>(207) 261 0947</p>
              <p>Info@ogunquit.com</p>
              <p>
                17 Post Rd, Wells,
                <br /> ME 04090
              </p>
            </div>
          </div>

          <div className={Classes.Footer_menu_Tertiory}>
            <div className={Classes.Footer_menu_Tertiory_signup}>
              Sign up to receive exclusive offers
            </div>
            <div className={Classes.Footer_menu_Tertiory_input_Mobile}>
              <div className={Classes.Footer_menu_Tertiory_input}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  className={Classes.Footer_menu_Tertiory_input_text}
                />
                <div
                  className={Classes.Footer_menu_Tertiory_signup_button_align}
                >
                  <button
                    className={`btn_primary `}
                    style={{ padding: "1rem" }}
                  >
                    SIGN UP
                  </button>
                </div>
              </div>
            </div>
          </div>
          <p className={Classes.Footer_Division_rod}></p>
          <div className={Classes.Footer_Bottom}>
            <div className={Classes.Footer_Bottom_left}>
              © 2021 Ogunquit River Inn | All Rights Reserved
            </div>
            <div className={Classes.Footer_Bottom_right}>
              Privacy Policy - Terms & Conditions
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
